import { GeneratedArtifactMeta } from './artifact';

export class CourseProgressSummary {
    CourseCode: string;
    CourseDescription: string;
    CourseShortDescription: string;
    TimeSpent: number;
    BooksRead: number;
    SongsSung: number;
    SpeechRecAttempts: number;
    Units: UnitProgress[];
    LastStartedActivity: Date;
}

export class UnitProgress {
    UnitNumber: number;
    TotalActivityAcount: number;
    CompletedActivityCount: number;
    StartedOn: Intl.DateTimeFormat;
    LastActivityCompletion: string;
    TimeSpent: number;
    UnitTested: boolean;
}

export class UnitProgressDetail extends UnitProgress {
    ActivityResults: ActivityResult[];
    Books: string[];
    Song: string;
}

export class ActivityResult {
    IsComplete: boolean;
    ActivityID: string;
    InteractionCode: string;
    Description1: string;
    Description2: string;
    Encounters: Encounter[];
    GeneratedArtifacts: GeneratedArtifactMeta[];
}

export class Encounter {
    ID: string;
    SkillType: string;
    SkillConcept: string;
    SkillDescription: string;
    Attempts: EncounterAttempt[];

    static getDescription(encounter: Encounter): string {
        return encounter.SkillDescription && !encounter.SkillDescription.includes("not_set") ? encounter.SkillDescription : encounter.SkillConcept;
    }
}

export class EncounterAttempt {
    CompletedAt: Date;
    Result: number;
}